import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { ContactDescription } from './ContactDescription/ContactDescription';
import { ContactForm } from './ContactForm/ContactForm';

import s from './Contact.scss';

export function Contact() {
	useStyles(s);
	return (
		<div className="sl-teams-contact" id="sl-teams-contact">
			<div className="sl-teams-contact__description-wrapper">
				<ContactDescription />
			</div>
			<div className="sl-teams-contact__form-wrapper">
				<ContactForm />
			</div>
		</div>
	);
}
